import React from "react";
import ContentLoader from "react-content-loader";

const NoticesPlaceholder = () => {
  return (
    <div>
      <ContentLoader viewBox="0 0 306 60" className="mb-3">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="16" />
        <rect x="0" y="20" rx="0" ry="0" width="80%" height="16" />
        <rect x="0" y="40" rx="0" ry="0" width="100" height="16" />
      </ContentLoader>
      <ContentLoader viewBox="0 0 306 60" className="mb-3">
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="16" />
        <rect x="0" y="20" rx="0" ry="0" width="80%" height="16" />
        <rect x="0" y="40" rx="0" ry="0" width="100" height="16" />
      </ContentLoader>
    </div>
  );
};

export default NoticesPlaceholder;
